import { Routes } from '@angular/router';
import { AppUrls } from '../../../../common/dto/app-urls';
import {
  LoggedInRouteGuard,
  NotLoggedInRouteGuard,
  NotValidatedEmailRouteGuard,
  ValidatedEmailRouteGuard,
} from '../common/routing/route-guards/session-check.guard';

export const AuthRoutes: Routes = [
  {
    path: AppUrls.Auth._.Login.relativeUrl,
    loadComponent: () => import('./login/login.component').then(_ => _.LoginComponent),
    canActivate: [
      NotLoggedInRouteGuard,
    ],
  },
  {
    path: AppUrls.Auth._.Registration.relativeUrl,
    loadComponent: () => import('./registration/registration.component').then(_ => _.RegistrationComponent),
    canActivate: [
      NotLoggedInRouteGuard,
    ],
  },
  {
    path: AppUrls.Auth._.ForgotPassword.relativeUrl,
    loadComponent: () => import('./forgot-password/forgot-password.component').then(_ => _.ForgotPasswordComponent),
    canActivate: [
      NotLoggedInRouteGuard,
    ],
  },
  {
    path: AppUrls.Auth._.PasswordReset.relativeUrl,
    loadComponent: () => import('./password-reset/password-reset.component').then(_ => _.PasswordResetComponent),
    canActivate: [
      NotLoggedInRouteGuard,
    ],
  },
  {
    path: AppUrls.Auth._.EmailValidation.relativeUrl,
    loadComponent: () => import('./email-validation/email-validation.component').then(_ => _.EmailValidationComponent),
    canActivate: [
      LoggedInRouteGuard,
      NotValidatedEmailRouteGuard,
    ],
  },
  {
    path: AppUrls.Auth._.EmailUnsubscribe.relativeUrl,
    loadComponent: () => import('./email-unsubscribe/email-unsubscribe.component').then(_ => _.EmailUnsubscribeComponent),
  },
];
